export class FacebookAccount {
  objectType;
  clientId;
  description;
  id;
  name;
  appId;
  secret;
  constructor(obj?: FacebookAccount) {
    for (const prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        this[prop] = obj[prop];
      }
    }
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/accounts/facebook-accounts/facebook-account.model.ts